import { createFileRoute } from "@tanstack/react-router";
import { LabPage, labHead } from "@/components/lab-page";

export const Route = createFileRoute("/lab/carga")({
  head: () => labHead(
    "/lab/carga",
    "Carga Alostática",
    "Laboratório Carga Alostática: dados ambientais e sociais traduzidos em imagem, luz e som, no projeto O que é a loucura? de Luiza Jesus do Prado.",
  ),
  component: CargaLab,
});

function CargaLab() {
  return <LabPage src="https://luizajprado.github.io/sirene/" title={{ pt: "Carga Alostática", en: "Allostatic Load", es: "Carga Alostática" }} />;
}